import eventStartLocalization from './events/eventStartLocalization';
import { trackerNameGA } from './index';

export default function () {
    if (window.ga) {
        window.ga(trackerNameGA(), 'event', eventStartLocalization);
    }
}
